/**
 * Actions
 *
 * ActionCreators are like the "pub" of pubsub. It's just broadcasting an event (action).
 * So, don't couple it with a specific reducer. Let ANY reducer listen to
 * an action.
 *
 * `typesafe-actions` has a nice utility function so we don't need to define action types as
 * constants. Use it together with `getType(type)` in the reducers.
 */
import { createAction } from "typesafe-actions";

import { LoadingFunc } from "src/ipm-shared/Utils/ReduxSagaEffects";

export const enterpriseOnboardingSubmit = createAction(
  "enterprise_onboarding/ENTERPRISE_ONBOARDING_SUBMIT",
  resolve => (cb?: any, loadingFunc?: LoadingFunc) =>
    resolve({ cb, loadingFunc })
);
